import { generateTranslations } from '../../i18n/translation';

const namespace = 'practiceactivity/agreements';

const translations = generateTranslations(namespace, {
  headerPraksissted: {
    nb: 'Praksissted',
    en: 'Practice place',
  },
  headerAvtale: {
    nb: 'Avtale',
    en: 'Agreement',
  },
  headerStatus: {
    nb: 'Status',
    en: 'Status',
  },
  headerBestilling: {
    nb: 'Bestilling',
    en: 'Places wanted',
  },
  headerKapasitet: {
    nb: 'Kapasitet',
    en: 'Capacity',
  },
  headerHandlinger: {
    nb: 'Handlinger',
    en: 'Actions',
  },
  overwriteCapacity: {
    nb: 'Meld inn kapasitet',
    en: 'Overwrite capacity',
  },
  overwriteCapacityDesc1: {
    nb: 'Du er i ferd med å melde inn kapasitet på vegne av { name }.',
    en: 'You are about to register capacity on behalf of { name }.',
  },
  overwriteCapacityDesc2: {
    nb: 'Det er ønskelig at praksissteder selv bekrefter egen kapasitet.',
    en: 'It is preferred that practice places confirm their own capacities.',
  },
  overwriteCapacityDesc3: {
    nb: 'En kvittering på denne hendelsen vil bli sendt til praksisstedet.',
    en: 'A notification of this action will be sent to the practice place',
  },
  emptyStateTitle: {
    nb: 'Savner du samarbeidsavtaler for denne praksisaktiviteten?',
    en: 'Missing agreements for this practice activity?',
  },
  emptyStateText: {
    nb: 'Gå til praksissteder for å opprette nye samarbeidsavtaler, eller kontakt en administrator med rettigheter til å lage nye avtaler.',
    en: 'Go to practice places to create new agreements, or contact an administrator with the privileges to create new agreements.',
  },
  emptyStateLink: {
    nb: 'Gå til praksissteder',
    en: 'Go to practice places',
  },
  actionButtonText: {
    nb: 'Velg handling',
    en: 'Choose action',
  },
  overwriteCapacityConfirm: {
    nb: 'Legg inn',
    en: 'Confirm',
  },
  overwriteCapacityAddCapacityFor: {
    nb: 'Legg inn kapasitet for { name }',
    en: 'Overwrite capacity for { name }',
  },
  deactivatePraksissted: {
    nb: 'Deaktiver',
    en: 'Disable',
  },
  activatePraksissted: {
    nb: 'Aktiver',
    en: 'Activate',
  },
  hidePraksissted: {
    nb: 'Skjul for studenter',
    en: 'Hide for students',
  },
  hiddenPraksissted: {
    nb: 'skjult',
    en: 'hidden',
  },
  showPraksissted: {
    nb: 'Synliggjør for studenter',
    en: 'Show students',
  },
  showAvtale: {
    nb: 'Vis avtale',
    en: 'Show agreement',
  },
  avtaleError: {
    nb: 'Feil i avtale',
    en: 'Erroneous agreement',
  },
  activePraksissted: {
    nb: 'Aktiv',
    en: 'Active',
  },
  deactivatedPraksissted: {
    nb: 'Deaktivert',
    en: 'Deactivated',
  },
  saveSuccess: {
    nb: 'Bestilling endret',
    en: 'Save successful',
  },
  save: {
    nb: 'Lagre utkast',
    en: 'Save draft',
  },
  share: {
    nb: 'Del med aktive praksissteder',
    en: 'Share with active practice places',
  },
  saveAndShare: {
    nb: 'Lagre og del',
    en: 'Save and share',
  },
  missingPraksisstedbrukerTitle: {
    nb: 'Fant ingen registrerte brukere på praksissted.',
    en: 'Could not find any registered users on practice place.',
  },
  missingPraksisstedbruker: {
    nb: 'Følgende praksissteder har ingen registrerte brukere som kan behandle bestillingen. Sjekk om en bruker har blitt invitert.',
    en: 'The following practice places has no registered users that can process the order. Make sure a user has been invited.',
  },
  missingPraksisstedbrukerSubmit: {
    nb: 'Del bestilling',
    en: 'Share order',
  },
  confirmActivityShare: {
    nb: 'Bekreft',
    en: 'Confirm',
  },
  omfattedeSteder: {
    nb: 'omfattede steder',
    en: 'included places',
  },
  moveBestillingTop: {
    nb: 'Flytt bestillinger til',
    en: 'Move orders to',
  },
  moveBestilling: {
    nb: 'Flytt bestillinger til dette nivået',
    en: 'Move orders to this level',
  },
  moveKapasitet: {
    nb: 'Flytt kapasitetspunkt hit',
    en: 'Move capacities here',
  },
  showRemainingPlaces: {
    nb: 'Vis resterende { numPlaces } steder',
    en: 'Show { numPlaces } remaining places',
  },
  hideRemainingPlaces: {
    nb: 'Skjul { numPlaces } steder',
    en: 'Hide { numPlaces } places',
  },
  confirmFlyttKapasitetTitle: {
    nb: 'Flytt kapasitetsinnmeldingen til nivået { level }',
    en: 'Move capacity registration to level { level }',
  },
  confirmFlyttKapasitetSubtitle: {
    nb: 'Bekreft endring av kapasitetspunkt i praksisaktiviteten',
    en: 'Confirm change in capacity registration point for the practice activity',
  },
  confirmFlyttKapasitetSubmitLabel: {
    nb: 'Flytt kapasitetspunkt',
    en: 'Move capacity registration',
  },
  confirmFlyttKapasitetSubmitContent: {
    nb: 'Du er i ferd med å endre hvilket nivå i hierarkiet som skal brukes for å melde kapasitet fra praksisstedene. Dette blir også stedet hvor studentene skal utføre sin praksis. Alle underliggende praksissteder vil bli markert som inaktive for avtalen i denne aktiviteten. Dersom kapasitetspunktet flyttes nedover i hierarkiet, vil de øverste praksisstedene, som ved flyttingen ikke vil få et kapasitetspunkt over seg, selv bli gjort til kapasitetspunkter.',
    en: 'You are about to move the place where the capacity will be registered by practice places. This will also be the point where the students will be assigned. All practice places below this point will be deactivated for the agreement in this activity. If the capacity point is moved downward, all leaf nodes that are not children of the parent node will be reactivated as capacity points.',
  },
  confirmFlyttKapasitetSubmitContentDeltMailWarning: {
    nb: 'En melding vil bli sendt til de berørte praksisstedene.',
    en: 'A message will be sent to all affected practice places.',
  },
  confirmFlyttKapasitetSubmitContentDeltPt1: {
    nb: 'Du er i ferd med å endre hvilket nivå i hierarkiet som skal brukes for å melde kapasitet fra praksisstedene. Dette blir også stedet hvor studentene skal utføre sin praksis. Dersom kapasitetspunktet flyttes nedover i hierarkiet, vil de øverste praksisstedene, som ved flyttingen ikke vil få et kapasitetspunkt over seg, selv bli gjort til kapasitetspunkter. Det er allerede meldt inn kapasitet ved',
    en: "You are about to move the place where the capacity will be registered by practice places. This will also be the point where the students will be assigned. If the capacity point is moved downward, all leaf nodes that are not children of the parent node will be reactivated as capacity points. There's already a set capacity for",
  },
  confirmFlyttKapasitetSubmitContentDeltPt2: {
    nb: 'Dette vil bli nullstilt, alle underliggende praksissteder vil bli markert som inaktive for avtalen i denne aktiviteten og en melding vil bli sendt til de berørte praksisstedene.',
    en: 'This will be reset, all practice places below this point will be deactivated for the agreement in this activity, and a message will be sent to all affected practice places.',
  },
  confirmFlyttKapasitetSubmitContentOnskeliste: {
    nb: 'Advarsel: Studenter har lagt til praksissteder som vil påvirkes av kapasitetsflyttingen i ønskelisten sin. Alle studentønsker til disse stedene vil slettes av denne handlingen.',
    en: 'Warning: Students have added practice places affected by this action to their wish lists. All affected student wishes will be deleted by this action.',
  },
  confirmFlyttKapasitetSubmitContentFordeling: {
    nb: 'Det er fordelt studenter til praksissteder som vil påvirkes av en slik kapasitetsflytting. Som en ekstra sikkerhet må disse fordeles bort fra påvirkede steder i fordelingsfanen, før denne handlingen er tillatt.',
    en: "There's students assigned to practice places affected by this action. As an extra precaution, the affected assignments must be handled in the assignments tab, before this action is permitted.",
  },
  inactiveByCapacity: {
    nb: 'Inaktiv pga. overliggende kapasitetspunkt',
    en: 'Inactive because of overlying capacity point',
  },
});

export default translations;
